// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "client/" + ({"41":"status-screens","112":"seating-plan-modal","680":"form"}[chunkId] || chunkId) + ".chunk.min.css";
};